export * from "./m1GenerateToken";
